import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  createServiceProvider,
  updateServiceProviderList,
} from "../ServiceProviderService";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { ServiceProviderFieldsJSON } from "../Json/ServiceProviderFieldsJson";
import { ServiceProviderLayoutJSON } from "../Json/ServiceProviderLayoutJson";
import { Card, CardBody } from "reactstrap";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../slices/common/reducer";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { getCategoryDropdown, getData } from "../../../../Utils/CommonService";
import UpdateConfirmationModal from "../Modal/UpdateConfirmationModal";
import SaveConfirmationModal from "../Modal/SaveConfirmationModal";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const AddServiceProvider = () => {
  const dispatch = useDispatch();
  const formState = useSelector((state) => state.common.formRendererState);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const [index, setIndex] = useState(0);
  const pspFieldJson = useSelector(
    (state) => state.serviceProvider.pspFieldJson
  );
  const navigator = useNavigate();
  const params = useParams();
  const editMode = !!params.id;
  const breadcrumbItems = editMode
    ? [
        { title: "PSP", link: "" },
        { title: "Product/Service provider", link: "/psp/psp" },
        {
          title: `${formState.code}`,
          link: `/psp/psp/update/${params.id}`,
        },
      ]
    : [
        { title: "PSP", link: "" },
        { title: "Product/Service provider", link: "/psp/psp" },
        {
          title: "New Product/Service Provider",
          link: "/psp/psp/create",
        },
      ];

  // const addNewClickHandler = (e) => {
  //   e.preventDefault();
  //   if (formState.status) {
  //     dispatch(setSelectValidError(false));
  //     createServiceProvider("PSP", formState, navigator);
  //   } else {
  //     dispatch(setSelectValidError(true));
  //   }
  // };

  // const updateClickHandler = (e) => {
  //   console.log("hii");
  //   e.preventDefault();
  //   if (formState.status) {
  //     dispatch(setSelectValidError(false));
  //     updateServiceProviderList(formState, params.id, navigator);
  //   } else {
  //     dispatch(setSelectValidError(true));
  //   }
  // };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    dispatch(verifyModal(false));
    navigator("/psp/psp");
  };

  const confirmSave = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createServiceProvider("PSP", formState, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  const confirmUpdate = (e) => {
    e.preventDefault(e);
    if (formState) {
      dispatch(setSelectValidError(false));
      updateServiceProviderList(formState, params.id, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  useEffect(() => {
    if (params.id) {
      getData(params.id, "PSP");
    }
  }, []);

  useEffect(() => {
    getCategoryDropdown("PSP", "psp_category", ServiceProviderFieldsJSON);
  }, []);
  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <Form
            onSubmit={editMode ? updateClickHandler : addNewClickHandler}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                // editMode ? updateClickHandler(e) : addNewClickHandler(e);
                editMode ? confirmUpdate(e) : confirmSave(e);
              }
            }}
          >
            {/* <CardHeader> */}
            {/* <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            /> */}
            <div>
              <div className="mb-3 tab">
                <div className="tab-item">
                  {ServiceProviderLayoutJSON.map((element, ind) => (
                    <div key={element.elementid}>
                      <div
                        className={`nav-link ${index === ind ? "active" : ""}`}
                        onClick={() => setIndex(ind)}
                      >
                        {renderElement(
                          element,
                          pspFieldJson,
                          formState,
                          {},
                          () => {
                            setIndex(ind);
                          }
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                {/* <CardBody> */}
                <div className="selected-tab-bottom-content">
                  {ServiceProviderLayoutJSON[index]?.child?.map((it) =>
                    renderElement(it, pspFieldJson, formState, {})
                  )}
                </div>

                <div className="form-footer">
                  <CommonButton
                    // handleSubmit={
                    //   editMode ? updateClickHandler : addNewClickHandler
                    // }
                    handleCancel={handleCancel}
                    edit={editMode}
                    update={editMode}
                    checkAccess={checkButtonAccess("EDIT", "PSP_PSP")}
                  />
                </div>
                {/* </CardBody> */}
                {verifyShow &&
                  (editMode ? (
                    <UpdateConfirmationModal confirmUpdate={confirmUpdate} />
                  ) : (
                    <SaveConfirmationModal confirmUpdate={confirmSave} />
                  ))}
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default AddServiceProvider;
